import { Center, Flex } from '@chakra-ui/layout';
import { Tooltip } from '@chakra-ui/react';
import copy from 'copy-to-clipboard';
import type { CombinedError } from 'urql';

import {
  DELIVERABLES_NAME_NOT_UNIQUE,
  DELIVERABLES_REPORT_EXISTS,
  ENTITY_NOT_FOUND,
} from '@revelio/data-access';

export const DEFAULT_ERROR_MSG = `We've run into an error and our team has been alerted. Please try again later.`;

const errorMessageDisplayTextLookup: Record<string, string> = {
  [ENTITY_NOT_FOUND]: `Currently the data for the selected Entity(ies) does not exist in our Dashboard. Feel free to reach out to your Revelio Labs contact for more information.`,
  [DELIVERABLES_NAME_NOT_UNIQUE]:
    'This deliverable name already exists. Please enter a unique name to continue.',
  [DELIVERABLES_REPORT_EXISTS]:
    'This report name already exists. Please enter a unique name to continue.',
};

export const getErrorMessageToDisplay = (errorMessage: string) => {
  const matchedKey = Object.keys(errorMessageDisplayTextLookup).find((key) =>
    errorMessage.includes(key)
  );

  if (matchedKey) {
    return errorMessageDisplayTextLookup[matchedKey];
  }

  return DEFAULT_ERROR_MSG;
};

export const UrqlAndTanstackErrorMessage = ({
  error,
  reqId,
}: {
  error: CombinedError | Error;
  reqId: string | undefined;
}) => {
  const message = getErrorMessageToDisplay(error.message);

  return (
    <>
      <Flex pb="12px">{message}</Flex>
      {reqId ? (
        <Tooltip hasArrow label="Copy to clipboard" placement="top">
          <Center
            cursor="pointer"
            fontSize="sm"
            opacity="50%"
            onClick={() => copy(`req-id: ${reqId}`)}
          >
            {reqId}
          </Center>
        </Tooltip>
      ) : (
        <span></span>
      )}
    </>
  );
};
